/**
 * **Bookassist**
 *
 * @exports partnership_2
 * @category partnerships
 */
function factory({ window, document, thn }) {
    const partnership = {};
    /**
       * @memberOf module:partnership_2
       */
    partnership.getId = function getId() {
        return '2';
    };
    /**
       * @memberOf module:partnership_2
       */
    partnership.check = function check() {
        return !thn.empty(window.BA);
    };
    const corpo = {
        // <hotel_group_id>: <accountKey>,
        898: '012515d9c572279e30e29db428868cee', // Fontecruz
        879: 'AF69E9D6D0A91123F7AE40191F5FE09A',
    };
    /**
       * @memberOf module:partnership_2
       */
    partnership.getSiteId = function getSiteId() {
        // Existance of window.BA is guaranteed by check()
        const BA = window.BA;
        // Note: hotel_id can be duplicated across different hotels
        // for that reason the unique identifier is <hotel_id>_<guide_id>
        let rrdocHotelId = '';
        const mainHotelId = (!thn.empty(BA.hotel_id)) ? BA.hotel_id : '';
        if (BA.rrDoc && BA.rrDoc.hotelID) {
            rrdocHotelId = (!thn.empty(BA.rrDoc.hotelID)) ? BA.rrDoc.hotelID : '';
        }
        else if (BA.rrDoc && BA.rrDoc.hotelId) {
            rrdocHotelId = (!thn.empty(BA.rrDoc.hotelId)) ? BA.rrDoc.hotelId : '';
        }
        const urlHotelId = thn.parseUrlParameter('hotel_id');
        const hotelId = mainHotelId || rrdocHotelId || rrdocHotelId || urlHotelId || '';
        const guideId = BA.guideId
            || (BA.rrDoc && (BA.rrDoc.guideID || BA.rrDoc.guideId))
            || thn.parseUrlParameter('guide_id');
        const hotelGroupId = BA.hotelGroupId
            || (BA.rrDoc && (BA.rrDoc.hotelGroupID || BA.rrDoc.hotelGroupId))
            || thn.parseUrlParameter('hotel_group_id');
        // The presence of <hotelId>_<guideId> means this is a hotel-specific page
        // even if this hotel has/belongs to a hotelGroupId
        if (!thn.empty(hotelId) && !thn.empty(guideId)
            && thn.isNumeric(hotelId) && thn.isNumeric(guideId)) {
            return `${hotelId}_${guideId}`;
        }
        // The absence of <hotelId>_<guideId> + the presence of <hotelGroupId>
        // means this is a non-hotel-specific page (thus a THN corporate script)
        if (!thn.empty(hotelGroupId) && thn.isNumeric(hotelGroupId)) {
            if (corpo[hotelGroupId]) {
                // If we already know to which corpo script does this
                // externalId map, then return directly
                return { accountKey: corpo[hotelGroupId] };
            }
            return `${hotelGroupId}`;
        }
        return '';
    };
    /**
       * @memberOf module:partnership_2
       */
    partnership.boot = function boot() {
        const container = document.querySelector('#booking_frame');
        if (!container) {
            thn.logger.debug('Partnership boot can\'t observe');
            return;
        }
        const bookassistIdentityObserver = thn.debounce(thn.siteCheck, 200);
        thn.observeDom(container, bookassistIdentityObserver, {
            childList: false,
            subtree: false,
            attributes: true,
            attributesFilter: ['style'],
        });
        partnership.shutdown = () => {
            bookassistIdentityObserver.cancel();
            thn.stopObserveDom(container, bookassistIdentityObserver);
        };
    };
    return partnership;
}

export { factory };
